// extracted by mini-css-extract-plugin
module.exports = {"scrollUp":"styles_scrollUp__F6dt3","slideInFromRight":"styles_slideInFromRight___3O0n"};